import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { UPDATE_SETTINGS } from "@ugg/shared/api/graphql/queries";
import { Checkbox } from "@ugg/shared/components/common/Checkbox";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";

const EmailSubscriptions = (props) => {
  const { userSettings, refetchQueries, setSettingsNotification } = props;
  const { marketingOptOut } = userSettings;

  const [marketingSub, setMarketingSub] = useState(!marketingOptOut);

  const [updateSettings, { loading, data, error }] = useMutation(UPDATE_SETTINGS, {
    variables: {
      marketingOptOut: !marketingSub,
    },
    refetchQueries,
    onCompleted: (data) => {
      setSettingsNotification(true);
    },
    onError: (error) => {
      setSettingsNotification(false);
    },
  });

  const verifyForm = () => {
    updateSettings();
  };

  return (
    <div className="settings-section email-subscriptions">
      <div className="section-content">
        <HeaderBullet className="mb-[24px]">Email Subscriptions</HeaderBullet>
        <div className="field-group">
          {/* <div className="field-label _with-helper-text">{"U.GG Newsletter"}</div>
          <div className="settings_helper_text">{"Marketing newsletter with handy stats and information"}</div> */}
          <div className="flex mt-[17px]">
            <Checkbox
              checkboxId="marketing-emails-newsletter"
              isChecked={marketingSub}
              onChange={(e) => setMarketingSub(e.target.checked)}
            />
            <label
              className="ml-[8px] text-[12px] leading-normal cursor-pointer text-lavender-100"
              htmlFor="marketing-emails-newsletter"
            >
              Keep me informed of any updates & features
            </label>
          </div>
        </div>
        <ButtonSuccess
          className="save-settings-btn btn-light-blue"
          label="Save Changes"
          isLoading={loading}
          onClick={verifyForm}
        />
      </div>
    </div>
  );
};

export default EmailSubscriptions;
